export function isNullOrUndefined(value) {
	return value === null || value === undefined;
}

export function isNullOrUndefinedOrNaN(value) {
	return isNullOrUndefined(value) || isNaN(value);
}
